import { render } from "./BaseViewHeader.vue?vue&type=template&id=58afe50c"
import script from "./BaseViewHeader.vue?vue&type=script&lang=js"
export * from "./BaseViewHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__